function getContentHeight(contentRef) {
  var height = 0;

  if (contentRef !== null && contentRef.current) {
    height = contentRef.current.offsetHeight;
  }

  return height;
}

export { getContentHeight };